export const STATUS = Object.freeze({
	IDLE: 'idle',
	ERROR: 'error',
	LOADING: 'loading'
});
